import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { X } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 grain relative" data-testid="cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-lg w-full relative z-10"
      >
        <div className="w-14 h-14 border border-white/20 flex items-center justify-center mb-8">
          <X className="w-7 h-7 text-white/60" />
        </div>
        <span className="text-white/40 text-xs uppercase tracking-[0.3em]">Cancelled</span>
        <h1 className="font-display font-bold uppercase tracking-tighter text-5xl md:text-6xl mt-3 leading-[0.9] text-white">
          No worries.
        </h1>
        <p className="text-white/60 mt-5 font-body">
          Your payment was cancelled and you haven't been charged. Your slot is still open — grab it when you're ready.
        </p>
        <Link
          to="/#book"
          data-testid="cancel-retry-btn"
          className="inline-block mt-8 bg-[#D4AF37] text-black px-7 py-4 text-sm uppercase tracking-[0.15em] font-semibold hover:-translate-y-0.5 transition-transform"
        >
          Pick a slot again →
        </Link>
      </motion.div>
    </div>
  );
}
